import React from 'react'
import Button from './Button'

export default function ResourceIndexHeader({
  count,
  singular,
  plural,
  addHref,
  addLabel,
  actions
}) {
  const label = count === 1 ? singular : plural

  return (
    <div className="mb-6 flex justify-between items-center">
      <p className="text-sm text-gray-600">
        {count} {label}
      </p>
      <div className="flex gap-2">
        {actions}
        <Button href={addHref}>
          {addLabel}
        </Button>
      </div>
    </div>
  )
}
